"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var AnchorContext = /*#__PURE__*/React.createContext(undefined);
var _default = AnchorContext;
exports["default"] = _default;